import { defineMessages } from 'react-intl';

export default defineMessages({
  address: {
    id: 'contactUs.address',
    defaultMessage: 'Address',
  },
  email: {
    id: 'contactUs.email',
    defaultMessage: 'E-mail',
  },
  phone: {
    id: 'contactUs.phone',
    defaultMessage: 'Phone',
  },
});
